<template>
    <div>
        <button class="btnAction  btn_link">
            <span>RACCOURCIS CLAVIER</span>
            <svg width="10" height="8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M1.175.5L5 4.827 8.825.5 10 1.832 5 7.5 0 1.832 1.175.5z" fill="#313131"></path>
            </svg>
        </button>
        <div class="card smallCard">
            <div class="ShortcutsSection">
                <table>
                    <tbody>
                        <tr>
                            <td class="shortcutsAlign">
                                <span class="shortcutTitle">
                                    {{' '}}
                                    Lecture/Pause{{' '}}
                                </span>
                            </td>
                            <td>
                                {{' '}}
                                <div class="shortcuts">
                                    <span class="shortcutKey">Espace</span>
                                </div>
                            </td>

                            <td>
                                <span class="shortcutTitle" style="{ marginLeft: '-7px' }">
                                    {{' '}}
                                    ou{{' '}}
                                </span>
                            </td>
                            <td>
                                <div class="shortcuts littleShortcuts" style="{ margin: '1px 7px 0px -4px' }">
                                    <span class="shortcutKey"> K</span>
                                </div>
                            </td>
                            <td>
                                <span class="shortcutTitle" style="{ marginLeft: '-37px' }">
                                    {{' '}}
                                    ou{{' '}}
                                </span>
                            </td>
                            <td>
                                <div class="shortcuts littleShortcuts" style="{ margin: '1px 7px 0px -23px' }">
                                    <span class="shortcutKey"> P</span>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td class="shortcutsAlign">
                                <span class="shortcutTitle">
                                    {{' '}}
                                    Avancer de 10 secondes{{' '}}
                                </span>
                            </td>
                            <td>
                                <div class="shortcuts littleShortcuts">
                                    <span class="shortcutKey"> L</span>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td class="shortcutsAlign">
                                <span class="shortcutTitle">
                                    {{' '}}
                                    Reculer de 10 secondes{{' '}}
                                </span>
                            </td>
                            <td>
                                <div class="shortcuts littleShortcuts">
                                    <span class="shortcutKey">J</span>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td class="shortcutsAlign">
                                <span class="shortcutTitle"> Plein écran </span>
                            </td>
                            <td>
                                <div class="shortcuts littleShortcuts">
                                    <span class="shortcutKey">F</span>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td class="shortcutsAlign">
                                <span class="shortcutTitle">
                                    {{' '}}
                                    Sous-titres/CC{{' '}}
                                </span>
                            </td>
                            <td>
                                <div class="shortcuts littleShortcuts">
                                    <span class="shortcutKey"> C</span>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td class="shortcutsAlign">
                                <span class="shortcutTitle">
                                    {{' '}}
                                    Mute/Démutez{{' '}}
                                </span>
                            </td>
                            <td>
                                <div class="shortcuts littleShortcuts">
                                    <span class="shortcutKey">M</span>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td class="shortcutsAlign">
                                <span class="shortcutTitle"> Volume </span>
                            </td>
                            <td>
                                <div style="{ display: 'flex' }">
                                    <div class="shortcuts littleShortcuts">
                                        <span class="shortcutKey"> &uarr;</span>
                                    </div>
                                    <div class="shortcuts littleShortcuts">
                                        <span class="shortcutKey">&darr;</span>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <span class="shortcutTitle" style="{ marginLeft: '-7px' }">
                                    {{' '}}
                                    ou{{' '}}
                                </span>
                            </td>
                            <td>
                                <div style="{ display: 'flex' }">
                                    <div class="shortcuts littleShortcuts" style="{ margin: '1px 15px 0px -4px'
                                }">
                                        <span class="shortcutKey">+</span>
                                    </div>
                                    <div class="shortcuts littleShortcuts" style="{ margin: '1px 7px 0px -4px'
                                }">
                                        <span class="shortcutKey">-</span>
                                    </div>
                                </div>

                            </td>


                        </tr>

                        <tr>
                            <td class="shortcutsAlign">
                                <span class="shortcutTitle">
                                    {{' '}}
                                    Afficher la liste des raccourcis clavier{{' '}}
                                </span>
                            </td>
                            <td>
                                {{' '}}
                                <div class="shortcuts littleShortcuts">
                                    <span class="shortcutKey"> O</span>
                                </div>
                            </td>

                        </tr>
                        <tr>
                            <td class="shortcutsAlign">
                                <span class="shortcutTitle">
                                    {{' '}}
                                    Fermer tous les modals{{' '}}
                                </span>
                            </td>
                            <td>
                                {{' '}}
                                <div class="shortcuts littleShortcuts">
                                    <span class="shortcutKey">ESC</span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="shortcutsAlign">
                                <span class="shortcutTitle">
                                    {{' '}}
                                    Diapositives{{' '}}
                                </span>
                            </td>
                            <td>
                                {{' '}}
                                <div class="shortcuts littleShortcuts">
                                    <span class="shortcutKey">D</span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="shortcutsAlign">
                                <span class="shortcutTitle">
                                    {{' '}}
                                    Chapitres{{' '}}
                                </span>
                            </td>
                            <td>
                                {{' '}}
                                <div class="shortcuts littleShortcuts">
                                    <span class="shortcutKey">H</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
    
<script>
export default {

    name: 'ShortcutSection',
    components: {

    },
    props: {

    }
}
</script>
  
<style>
.shortcutTitle {
    font-size: 12px;
    text-align: right;
    color: var(--vm-modal-font-color);
    margin: 6px 6px 0 0;
}

.shortcutKey {
    font-size: 12px;
    text-align: center;
    color: var(--vm-shortcut-front-color);
    display: flex;
    justify-content: center;
}

.shortcuts {
    height: 20px;
    width: 55px;
    margin: 1px 7px 0px 4px;
    border-radius: 2px;
    background-color: var(--vm-modal-font-color);
}

.littleShortcuts {
    width: 24px;
}

.ShortcutsSection {
    margin: 5px 0px 5px 70px;
}

.shortcutsAlign {
    text-align: right;
}

.scale_100 {
    max-height: 416px !important;
}

@keyframes breathing {
    0% {
        transform: scale(0.9);
    }

    25% {
        transform: scale(1.1);
    }

    60% {
        transform: scale(1.1);
    }

    100% {
        transform: scale(0.9);
    }
}
</style>